export enum CountryEnum {
  UNITED_STATES = '1',
  CANADA = '39',
  UK = '224',
  AU = '15',
  FRANCE = '75',
}
